// extracted by mini-css-extract-plugin
module.exports = {"notFound":"NotFound_notFound__A4t-D","logo":"NotFound_logo__fKley"};